var React = require('react');

function QuestionGoldBg (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"10","cy":"10","r":"10","fill":"#EBA920","key":0}),React.createElement("path",{"d":"M8.932 13.1C8.932 13.688 9.388 14.12 9.976 14.12C10.564 14.12 11.032 13.688 11.032 13.1C11.032 12.512 10.564 12.068 9.976 12.068C9.388 12.068 8.932 12.512 8.932 13.1ZM9.232 7.652C9.268 7.304 9.568 6.92 10.096 6.92C10.612 6.92 10.96 7.22 10.96 7.664C10.96 8.612 9.04 8.888 9.04 10.436C9.04 11.108 9.46 11.588 9.592 11.744L10.804 10.904C10.696 10.796 10.6 10.676 10.6 10.472C10.6 9.752 12.52 9.404 12.52 7.64C12.52 6.404 11.452 5.48 10.096 5.48C8.788 5.48 7.936 6.308 7.72 7.256L9.232 7.652Z","fill":"#FFFBE7","key":1})]);
}

QuestionGoldBg.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = QuestionGoldBg;

QuestionGoldBg.default = QuestionGoldBg;
